export const termsPolicyAndContactConstants = {
 
   ADD_STATIC_PAGE_REQUEST:      'ADD_STATIC_PAGE_REQUEST',
   ADD_STATIC_PAGE_SUCCESS:      'ADD_STATIC_PAGE_SUCCESS',
   ADD_STATIC_PAGE_FAILURE:      'ADD_STATIC_PAGE_FAILURE',
   GET_STATIC_PAGE_REQUEST:      'GET_STATIC_PAGE_REQUEST',
   GET_STATIC_PAGE_SUCCESS:      'GET_STATIC_PAGE_SUCCESS',
   GET_STATIC_PAGE_FAILURE:      'GET_STATIC_PAGE_FAILURE',
   GET_STATIC_PAGE_DETAILS_REQUEST:'GET_STATIC_PAGE_DETAILS_REQUEST',
   GET_STATIC_PAGE_DETAILS_SUCCESS:'GET_STATIC_PAGE_DETAILS_SUCCESS',
   GET_STATIC_PAGE_DETAILS_FAILURE:'GET_STATIC_PAGE_DETAILS_FAILURE',
   GET_BECOMEAPARTNER_REQUEST: 'GET_BECOMEAPARTNER_REQUEST',
   GET_BECOMEAPARTNER_SUCCESS: 'GET_BECOMEAPARTNER_SUCCESS',
   GET_BECOMEAPARTNER_FAILURE: 'GET_BECOMEAPARTNER_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/termsPolicyAndContactConstants.js